import React from 'react';

import {
  UserSettingsSlug,
  userSettingsRouteConfig,
} from 'src/app/account/routes';
import { L3SettingsMenu } from 'src/components/l3SettingsMenu/L3SettingsMenu';
import { useRouteParams } from 'src/hooks/useRouteParams';

const userSettingsMenuItems: ReadonlyArray<{
  slug: UserSettingsSlug;
  title: string;
}> = [
  { slug: 'general', title: 'General' },
  { slug: 'api-keys', title: 'API Keys' },
];

export const UserSettingsMenu = () => {
  const { tab } = useRouteParams(userSettingsRouteConfig);

  const applyRouteConfig = (tabName: UserSettingsSlug) => {
    return userSettingsRouteConfig.location({
      tab: tabName,
    });
  };

  return (
    <>
      <L3SettingsMenu
        settingsMenuItems={userSettingsMenuItems}
        applyRouteConfig={applyRouteConfig}
        defaultSlug="general"
        currentTab={tab}
      />
    </>
  );
};
